<template>
  <div>
    <div id="oauth-success" class="flex center" style="flex-direction:column">
      <img width="450" src="@/assets/img/happy.png" />
      <h3>Acesso realizado com sucesso!</h3>
      <p>
        Aguarde alguns segundos até o sistema liberar.
      </p>

      <div class="buttons small">
        <div @click="closeWindow()" class="button secondary">
          Fechar Janela
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import logo5 from "@/assets/img/integration/logo-5.png";

export default {
  name: "loginOauth",
  data() {
    return {
      auth_token: null,
      account_id: null,
    };
  },
  mounted() {
    const params = new URLSearchParams(window.location.search)

    this.auth_token = params.get('auth_token')
    this.account_id = params.get('account_id')

    if (!this.auth_token || !this.account_id) {
      return
    }

    this.$store.dispatch("auth", { token: this.auth_token, account: this.account_id });
  },
  methods: {
    closeWindow() {
      window.open("", "_parent", "");
      window.close();
    },
  },
};
</script>

<style lang="scss" scoped>
#oauth-success {
  padding-top: 30px;
  align-items: center;
  img {
    margin-bottom: 30px;
  }
  .buttons {
    margin-top: 30px;
  }
}
</style>
